var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 68,
    viewBox: "0 0 134 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4473 12.1016L131.96 20.5214C131.991 20.5262 131.987 20.5573 131.955 20.5526L63.6789 23.6628L65.4473 12.1016Z",
    stroke: "white",
    strokeWidth: 3.01082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.148 20.5504L72.0748 34.0362L70.5221 23.3384",
    stroke: "white",
    strokeWidth: 3.01082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 43.3067C27.5 29.3066 57.0797 27.8205 57.0797 27.8205",
    stroke: "white",
    strokeWidth: 3.01082,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.344,
    height: 48.8,
    fill: "white",
    transform: "translate(7.80518) rotate(8.69657)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.f13fc69ce932eae7c055a534de714fe9.svg";
export { ForwardRef as ReactComponent };